/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Article } from '../models/Article';
import type { RegionalSummary } from '../models/RegionalSummary';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ArticleService {
    /**
     * Returns articles by date
     * @returns Article Returned when successful
     * @throws ApiError
     */
    public static getArticleByDate({
        year,
        month,
        day,
    }: {
        year: string,
        month: string,
        day: string,
    }): CancelablePromise<Article> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/articles/{year}/{month}/{day}',
            path: {
                'year': year,
                'month': month,
                'day': day,
            },
            errors: {
                404: `Returned when the article does not exist`,
            },
        });
    }
    /**
     * Returns the latest article
     * @returns Article Returned when successful
     * @throws ApiError
     */
    public static getLatestArticle(): CancelablePromise<Article> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/articles/latest',
            errors: {
                404: `Returned when the article does not exist`,
            },
        });
    }
    /**
     * Returns latest regional summary
     * @returns RegionalSummary Returned when successful
     * @throws ApiError
     */
    public static getLatestRegionalSummary({
        region,
    }: {
        region: string,
    }): CancelablePromise<RegionalSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/regional-summary/{region}/latest',
            path: {
                'region': region,
            },
            errors: {
                404: `Returned when the regional-summary does not exist`,
            },
        });
    }
}
